import styled from 'styled-components';

const SliderArrow = styled.button<{ $zIndex?: string }>`
  position: absolute;
  top: 50%;
  width: 6.5625vw;
  height: 6.5625vw;
  margin-top: -3.28125vw;
  z-index: ${({ $zIndex }) => $zIndex || 11};
  outline: none;
  border: 0;
  border-radius: 50%;
  background-size: cover;
  background-color: transparent;

  @media only screen and (min-width: 480px) {
    width: 24px;
    height: 24px;
    margin-top: -12px;
  }
`;

export const ArrowNext = styled(SliderArrow)`
  background-image: url('/static/images/item-slider-arrow-right.svg');
  right: 3.125vw;
  left: auto;

  @media only screen and (min-width: 480px) {
    right: 10px;
  }
`;

export const ArrowPrev = styled(SliderArrow)`
  background-image: url('/static/images/item-slider-arrow-left.svg');
  left: 3.125vw;
  right: auto;

  @media only screen and (min-width: 480px) {
    left: 10px;
  }
`;
